import { Component, Input } from '@angular/core';

@Component({
  selector: 'itl-desktop-page-list',
  templateUrl: './desktop-page-list.component.html',
  styleUrls: ['./desktop-page-list.component.scss'],
  standalone: false,
})
export class DesktopPageListComponent {
  @Input() noSearchbar = false;
}
